import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './page-refresh.component.html',
  styleUrls: ['./page-refresh.component.scss']
})
export class PageRefreshComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
